/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Send_Success_AriaInputs */

const en_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent`)
};

const ar_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إرسال الرسالة`)
};

const bn_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বার্তা পাঠানো হয়েছে`)
};

const de_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht gesendet`)
};

const es_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje enviado`)
};

const fr_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message envoyé`)
};

const pt_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem enviada`)
};

const zh_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息已发送`)
};

const tr_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj gönderildi`)
};

const ru_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение отправлено`)
};

const pl_form_send_success_aria = /** @type {(inputs: Form_Send_Success_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość wysłana`)
};

/**
* | output |
* | --- |
* | "Message sent" |
*
* @param {Form_Send_Success_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_send_success_aria = /** @type {((inputs?: Form_Send_Success_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Send_Success_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_send_success_aria(inputs)
	if (locale === "bn") return bn_form_send_success_aria(inputs)
	if (locale === "de") return de_form_send_success_aria(inputs)
	if (locale === "es") return es_form_send_success_aria(inputs)
	if (locale === "fr") return fr_form_send_success_aria(inputs)
	if (locale === "pt") return pt_form_send_success_aria(inputs)
	if (locale === "zh") return zh_form_send_success_aria(inputs)
	if (locale === "tr") return tr_form_send_success_aria(inputs)
	if (locale === "ru") return ru_form_send_success_aria(inputs)
	if (locale === "pl") return pl_form_send_success_aria(inputs)
	return en_form_send_success_aria(inputs)
});